import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { UserFilterSchema } from '../userSchema';
import { UserListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'USER'

export function UserFiltering(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Users");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [userData, setUserData] = useState([]);
    const [user, setUser] = useState({
        groupID: '0',
        operationEntityID: '0',
        
    });
     const [multipleEstates, setMultipleEstates] = useState([]);
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(UserFilterSchema).options({ allowUnknown: true });


    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [user.groupID]);

    useEffect(() => {
        if(user.operationEntityID != '0'){
            handleSearch();
        }
    }, [user.operationEntityID]);


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUSERLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITUSER');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)
        }

        setUser({
            ...user,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntity = await services.getAllOperationEntitiesForDropDown(user.groupID);
        setOperationEntity(operationEntity);
    }

    function handleGroupChange(target){
        validateInputs(target);

        setUser({
            groupID: target.value,
            operationEntityID: '0'
        });
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setUser({
            ...user,
            operationEntityID: target.value
        });
    }

    function validateInputs(target){
        const error = { ...errors };
        const errorMessage = validateProperty(target, UserFilterSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        if(e !== undefined){
            const errorMessages = validate(schema, user);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getUserFilterData(user);
        setUserData(response);
      
    }

    function editUser(data) {
        props.history.push({
            pathname: 'users/addEdit',
            data: data,
            edit: true
        });
    }

    function handleReset(users) {
        props.history.push({
            pathname: '/users/userPasswordChange',
            data: users,
            edit: true
        })
    }

    function clearState() {
        setUser({
            ...user,
            groupID: '0',
            operationEntityID: '0',
        });
        setUserData([]);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={permissionList.isAddEditEnabled}
                                    path="users/AddEdit"
                                    buttonText="Add User"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSearch(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={user.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={user.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? operationEntity : multipleEstates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>                                 
                                </div>

                                <UserListing userData={userData} handleClick={editUser} handleReset={handleReset} />

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}